/* eslint-disable import/prefer-default-export */
export const activeClassName = 'js-active-accordion';
